import { useContext } from "react";
import { MainContext } from "../App";
import CartIcon from "../icons/CartIcon";

export default function Footer() {
	const {
		table,
		setCartVisible,
		setPopupVisible,
		lockTable,
		cart,
		user,
		ordersDisabled,
		setTempTable,
		setTableEditPopup,
	} = useContext(MainContext);
	const isAdmin = parseInt(user?.role?.admin) === 1;
	const canViewRequestBill =
		isAdmin || parseInt(user?.role?.waiter_permissions?.request_bill?.view) === 1;
	const isNewOrder = !cart?.order_id;
	const showRequestBillButton = canViewRequestBill && !isNewOrder;
	const showTableEditButton = !ordersDisabled && table?.status == 1;
	const footerClassName =
		showTableEditButton && showRequestBillButton
			? "four-buttons"
			: showTableEditButton || showRequestBillButton
				? "three-buttons"
				: "two-buttons";

	const getProductsCount = () => {
		let t = 0;
		for (const p of cart.products) {
			t += parseInt(p.qty);
		}
		return t;
	};

	return (
		<footer className={footerClassName}>
			{showTableEditButton && (
				<button
					onClick={() => {
						setTempTable(table);
						setTableEditPopup(true);
					}}
					className="btn btn-tertiary btn-block footer-table-edit-btn"
				>
					<div className="footer-table-edit-copy">
						<div className="footer-table-edit-label">Modifica</div>
						<div className="footer-table-edit-table">{table?.name}</div>
					</div>
				</button>
			)}
			{table?.status == 1 ? (
				<button
					onClick={() => setPopupVisible("history")}
					className="btn btn-primary btn-block footer-orders-btn"
				>
					<div className="footer-orders-copy">
						<div className="footer-orders-label">Storico</div>
						<div className="footer-orders-count">{table.orders_count} ordini</div>
					</div>
				</button>
			) : (
				<button className="btn btn-tertiary btn-block footer-orders-btn">
					<div className="footer-orders-copy">
						<div className="footer-orders-label">Storico</div>
						<div className="footer-orders-count">0 ordini</div>
					</div>
				</button>
			)}
			{showRequestBillButton &&
				(table?.status == 1 ? (
					<button onClick={() => lockTable()} className="btn btn-secondary btn-block">
						Richiedi conto
					</button>
				) : (
					<button className="btn btn-tertiary btn-block">Richiedi conto</button>
				))}
			<button
				onClick={() => setCartVisible(true)}
				className="btn btn-secondary btn-block footer-cart-btn"
			>
				<span className="footer-cart-icon-wrap">
					<CartIcon />
					<span className="footer-cart-badge">{getProductsCount()}</span>
				</span>
				<span className="footer-cart-label">Invia</span>
			</button>
		</footer>
	);
}
